"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Button = _interopRequireDefault(require("../Button"));

var _LFCProvider = require("../LFCProvider");

var _Text = _interopRequireDefault(require("../Text"));

var _CalendarFooter = _interopRequireDefault(require("./CalendarFooter.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var FooterContainer = _styledComponents.default.div.withConfig({
  displayName: "CalendarFooter__FooterContainer",
  componentId: "sc-11q7sm4-0"
})(["display:flex;flex-direction:", ";gap:", ";padding:", ";justify-content:space-between;align-items:center;border-width:1px;border-color:", ";border-style:solid;"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? 'column' : 'row';
}, function (_ref2) {
  var isMobile = _ref2.isMobile,
      theme = _ref2.theme;
  return isMobile && theme.space.xxtiny;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.small;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.greyMedium;
});

var ButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "CalendarFooter__ButtonContainer",
  componentId: "sc-11q7sm4-1"
})(["display:flex;gap:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.small;
});

var CalendarFooter = function CalendarFooter(props) {
  var labels = props.labels,
      theme = props.theme,
      isMobile = props.isMobile,
      disableButtons = props.disableButtons,
      isPartialHotelCalendar = props.isPartialHotelCalendar,
      onResetClick = props.onResetClick,
      onConfirmClick = props.onConfirmClick,
      isTwoWay = props.isTwoWay,
      selectingDepart = props.selectingDepart,
      selectingReturn = props.selectingReturn;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _ref6 = labels || {},
      labelReset = _ref6.labelReset,
      labelConfirm = _ref6.labelConfirm,
      footerLabelOneWay = _ref6.footerLabelOneWay,
      footerLabelDepart = _ref6.footerLabelDepart,
      footerLabelReturn = _ref6.footerLabelReturn,
      noFareLabel = _ref6.noFareLabel;

  var lfcContext = (0, _react.useContext)(_LFCProvider.LFCContext);

  var _ref7 = lfcContext || {},
      lowFares = _ref7.lowFares;

  var getLowestFareLabel = function getLowestFareLabel() {
    var label;

    if (lowFares) {
      if (isTwoWay) {
        if (selectingDepart) label = footerLabelDepart && footerLabelDepart.replace('{0}', lowFares.currency);
        if (selectingReturn) label = footerLabelReturn && footerLabelReturn.replace('{0}', lowFares.currency);
      } else label = footerLabelOneWay && footerLabelOneWay.replace('{0}', lowFares.currency);
    } else label = noFareLabel;

    return label;
  };

  var getButton = function getButton(type) {
    var isResetButton = type === _constant.TYPE.RESET;
    var isConfirmButton = type === _constant.TYPE.CONFIRM;
    var confirmBtnId = isPartialHotelCalendar ? _constant.BTN_DEFAULTS.CONFIRM_ID_PHOTEL : _constant.BTN_DEFAULTS.CONFIRM_ID;

    var onClickHandler = function onClickHandler() {
      if (!disableButtons) {
        if (isResetButton && onResetClick) onResetClick();
        if (isConfirmButton && onConfirmClick) onConfirmClick();
      }
    };

    var label = isResetButton ? labelReset : labelConfirm;
    return label && /*#__PURE__*/_react.default.createElement(_Button.default, {
      id: isConfirmButton ? confirmBtnId : _constant.BTN_DEFAULTS.RESET_ID,
      border: isResetButton && (disableButtons ? _constant.BTN_DEFAULTS.BORDER_DISABLED : _constant.BTN_DEFAULTS.BORDER),
      paddingLeft: _constant.BTN_DEFAULTS.PADDING,
      paddingRight: _constant.BTN_DEFAULTS.PADDING,
      handleClick: onClickHandler,
      disabled: disableButtons,
      backgroundColor: isConfirmButton && _constant.BTN_DEFAULTS.BACKGROUND_COLOR,
      color: isConfirmButton && _constant.BTN_DEFAULTS.COLOR
    }, label);
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(FooterContainer, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: _constant.LABEL_DEFAULTS.TYPE,
      color: _constant.LABEL_DEFAULTS.COLOR,
      theme: theme
    }, getLowestFareLabel()), /*#__PURE__*/_react.default.createElement(ButtonContainer, null, getButton(_constant.TYPE.RESET), getButton(_constant.TYPE.CONFIRM)));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

CalendarFooter.propTypes = _CalendarFooter.default.PropTypes;
CalendarFooter.defaultProps = _CalendarFooter.default.DefaultProps;
var _default = CalendarFooter;
exports.default = _default;